export default {"src":"/_next/static/media/germanDocument_40.9b35d11c.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};